export const DETAIL = {
  FAIL_FETCH: "DETAIL_FAIL_FETCH",
  SUCCESS_FETCH: "DETAIL_SUCCESS_FETCH",
};
